import React from "react";
import styled from "styled-components";
import ShowtimeButton from "./ShowtimeButton";
import { MovieType } from "../../../types/entities";

const Grid = styled.div<{ childrenCount: number }>`
    display: grid;
    gap: 0.5em;
    grid-template-columns: ${props => props.childrenCount < 4 ? '1fr 1fr 1fr 1fr' : 'repeat(auto-fit, minmax(min(7rem, 100%), 1fr))'};
`;

interface PropsWithChildren {
    children: React.ReactNode,
};
interface PropsWithVersion {
    movie: MovieType,
    version: { label: string, sessions: any[] }, // @todo Define model
};

function ShowtimesGrid(props: PropsWithChildren);
function ShowtimesGrid(props: PropsWithVersion);

function ShowtimesGrid(props: any) {
    const { children, version, movie } = props;
    
    return <Grid childrenCount={version ? version.sessions.length : children ? React.Children.count(children) : 0}>
        {children ? children : null}
        {!!version && !!movie && version.sessions.map(session => <ShowtimeButton
            key={session.id}
            session={session}
            version={version.label}
            movieName={movie.name}
        />)}
    </Grid>
}

export default ShowtimesGrid;